import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { HIPAA } from 'constants/constants'
import {
  setToStorage,
  getFromStorage,
  removeFromStorage
} from 'utils/localStorage'
import {
  getFromSessionStorage,
  removeFromSessionStorage
} from 'utils/sessionStorage'
import logo from 'assets/logo.svg'
import { HIPAA_PATH, TICKETS_PATH } from 'constants/routes'
import { Button, Modal } from 'ui/styled'
import { signOut } from 'apollo/auth'
import useUserStore from 'stores/user'
import useCarePodsStore from 'stores/carePods'

import { LoginLogo, LogoImage, Content, Text } from './styled'

const i18n = {
  agreement:
    "This software will give you access to information that is covered under HIPAA. These are our customer's personal details. Our company and every member are bound by law to protect and respect our customer's data.  Non-HIPAA video recording including cell phone recordings and any other non-HIPAA compliant use of this software is a violation of our customer's trust.  Treat our customer's data like your own.  It's not just good for everyone involved, HIPAA compliance is legally required.",
  confirm: 'I Agree To Follow HIPAA Guidelines',
  disable: 'I do not want to Access The Advocate'
}

const HipaaModal = ({ visible = true }) => {
  const navigate = useNavigate()
  const lastVisitedPage = getFromSessionStorage('lastVisitedPage')()
  const originalLink = getFromStorage('originalLink')()
  const userId = useUserStore(s => s.userId)
  const userName = useUserStore(s => s.userName)
  const carePodNames = useCarePodsStore(s => s.carePodNames)

  const setHipaaAgreement = () => {
    setToStorage(HIPAA)(Date.now())
    // eslint-disable-next-line no-undef
    freshpaint.identify(userId, { id: userId, name: userName, carePodNames })
    if (lastVisitedPage) {
      removeFromSessionStorage('lastVisitedPage')
      navigate(lastVisitedPage === HIPAA_PATH ? TICKETS_PATH : lastVisitedPage)
    } else if (originalLink) {
      removeFromStorage('originalLink')
      navigate(originalLink)
    } else {
      navigate(TICKETS_PATH)
    }
  }

  return (
    <Modal open={visible} closable={false} width="820px" footer={null}>
      <>
        <LoginLogo>
          <LogoImage src={logo} alt="Rightway Healthcare" />
        </LoginLogo>
        <Content>
          <Text>{i18n.agreement}</Text>
        </Content>
        <Button
          onClick={setHipaaAgreement}
          btntype="primary"
          margin="10px 0"
          width="100%"
          data-test="hipaaModalConfirmBtn"
        >
          {i18n.confirm}
        </Button>
        <Button
          btntype="link"
          margin="10px 0"
          width="100%"
          data-test="hipaaModalCancelBtn"
          onClick={signOut}
        >
          {i18n.disable}
        </Button>
      </>
    </Modal>
  )
}

HipaaModal.propTypes = {
  visible: PropTypes.bool.isRequired
}

export default HipaaModal
